const initStyles = [
    "background: #4B275F",
    "color: #C4A36A",
    "padding: 10px 12px",
    "font-size: 18px",
    'font-family: "Sofia Pro", sans-serif',
    "display: block",
    "margin: 10px 0",
    "font-weight: 400",
].join(';');
console.log('%cCASDIM PARFUMERIE', initStyles);
/* ========================================================================== */
/*                       COLLAPSABLE CONTENT SETTINGS                         */
/* ========================================================================== */
function switchToggleIcon(toggle, isActive) {
  // If toggle itself is a chevron icon
  if (toggle.classList.contains('bi-chevron-down') || toggle.classList.contains('bi-chevron-up')) {
    if (isActive) {
      toggle.classList.remove('bi-chevron-down');
      toggle.classList.add('bi-chevron-up');

      toggle.setAttribute('aria-label', 'Collapse content');
      toggle.setAttribute('aria-expanded', 'true');
    } else {
      toggle.classList.remove('bi-chevron-up');
      toggle.classList.add('bi-chevron-down');

      toggle.setAttribute('aria-label', 'Expand content');
      toggle.setAttribute('aria-expanded', 'false');
    }
    return;
  }

  toggle.setAttribute('aria-expanded', isActive ? 'true' : 'false');
  // If a child of toggle is a chevron icon
  const chevron = toggle.querySelector('.bi-chevron-down, .bi-chevron-up');
  if (chevron) {
    if (isActive) {
      chevron.classList.remove('bi-chevron-down');
      chevron.classList.add('bi-chevron-up');

      chevron.setAttribute('aria-label', 'Collapse content');
      chevron.setAttribute('aria-expanded', 'true');
    } else {
      chevron.classList.remove('bi-chevron-up');
      chevron.classList.add('bi-chevron-down');

      chevron.setAttribute('aria-label', 'Expand content');
      chevron.setAttribute('aria-expanded', 'false');
    }
  }
}

function toggleCollapsableContent(content, toggle) {
  // Toggle the last child to active 
  const lastChild = content.lastElementChild;
  if (lastChild) {
    lastChild.classList.toggle('active');
  }

  switchToggleIcon(toggle, lastChild.classList.contains('active'));

  if (lastChild.classList.contains('active')) {
    // Set max-height to content height + last child's height
    lastChild.style.maxHeight = `${lastChild.scrollHeight}px`;

    lastChild.removeAttribute('inert');
    toggle.setAttribute('aria-expanded', 'true');
  } else {
    lastChild.style.maxHeight = '0px';

    lastChild.setAttribute('inert', '');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.style.opacity = '1';
  }
}

window.closeAllCollapsableContents = function() {
  document.querySelectorAll('.collapsable-content').forEach(content => {
    const lastChild = content.lastElementChild;
    const toggle = content.querySelector('.toggle__collapsable-content');
    if (lastChild && lastChild.classList.contains('active')) {
      lastChild.classList.remove('active');
      lastChild.style.maxHeight = '0px';
      if (toggle) switchToggleIcon(toggle, false);
    }
  });
};

function initCollapsableContents() {
  document.querySelectorAll('.collapsable-content').forEach(content => { 
    const toggle = content.querySelector('.toggle__collapsable-content');
    toggle.setAttribute('aria-controls', content.lastElementChild.id || '');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('role', 'button');
    
    if (!toggle || content.classList.contains('collapsable-content__external-toggle')) {
      return;
    }

    // Always allow click to toggle for mobile
    const handleClick = () => {
      if (document.documentElement.clientWidth < 1025) {
        toggleCollapsableContent(content, toggle);
      }
    };

    if (content.classList.contains('toggle-click') || !content.classList.contains('toggle-hover')) {
      toggle.addEventListener('click', () => {    
        toggleCollapsableContent(content, toggle);
      });
    } else if (content.classList.contains('toggle-hover')) {
      // On desktop, switch icons on hover
      content.addEventListener('mouseenter', () => {
        if (document.documentElement.clientWidth > 1025) {
          switchToggleIcon(toggle, true);
        }
      });
      content.addEventListener('mouseleave', () => {
        if (document.documentElement.clientWidth > 1025) {
          switchToggleIcon(toggle, false);
        }
      });
      // On mobile, toggle open/close on click
      toggle.addEventListener('click', handleClick);
    }
  });
}

/* ========================================================================== */
/*                  HAMBURGER MENU POSITIONING LOGIC                          */
function closeAllHamburgers() {
  document.querySelectorAll('.hamburger__menu').forEach(menuContainer => {
    const menu = menuContainer.lastElementChild;
    const toggle = menuContainer.querySelector('.hamburger__toggle');
    if (menu.classList.contains('active')) {
      toggleHamburgerMenu(menuContainer, toggle);
    }
  });
}
window.closeAllDropdowns = closeAllHamburgers;

function toggleHamburgerMenu(menuContainer, toggle) {
  const lastChild = menuContainer.lastElementChild;

  if (lastChild) {
    lastChild.classList.toggle('active');
  } else {
    console.warn('No menu found in hamburger menu container:', menuContainer);
    return;
  }

  const isActive = lastChild.classList.contains('active');
  if (toggle) toggle.setAttribute('aria-expanded', isActive ? 'true' : 'false');
  
  
  if (isActive) {
    lastChild.removeAttribute('inert');
  } else {
    lastChild.setAttribute('inert', '');
  }

  // Update the toggle icon - depending where the user toggled from 
  let toggleIcon = toggle;
  if (toggle && toggle.classList.contains('content__toggle')) {
    // If the toggle is inside content, also update the main toggle icon
    toggleIcon = menuContainer.firstElementChild;
  } else if (toggle && toggle.querySelector('.toggle-icon')) {
    toggleIcon = toggle.querySelector('.toggle-icon');
  }

  if (isActive && toggleIcon) {
    if (toggleIcon.classList.contains('bi-list')) {
      toggleIcon.classList.remove('bi-list');
      toggleIcon.classList.add('bi-x-lg');
    } else if (toggleIcon.classList.contains('bi-chevron-right')) {
      toggleIcon.classList.remove('bi-chevron-right');
      toggleIcon.classList.add('bi-chevron-left');
    }

  } else if (toggleIcon) {
    if (toggleIcon.classList.contains('bi-x-lg')) {
      toggleIcon.classList.remove('bi-x-lg');
      toggleIcon.classList.add('bi-list');
    } else if (toggleIcon.classList.contains('bi-chevron-left')) {
      toggleIcon.classList.remove('bi-chevron-left');
      toggleIcon.classList.add('bi-chevron-right');
    }

    // If there are nested hamburger menus, close them as well
    lastChild.querySelectorAll('.hamburger__menu').forEach(nestedMenuContainer => {
      const nestedMenu = nestedMenuContainer.lastElementChild;
      const nestedToggle = nestedMenuContainer.querySelector('.hamburger__toggle');

      if (nestedMenu.classList.contains('active')) {
        toggleHamburgerMenu(nestedMenuContainer, nestedToggle);
      }
    });

    lastChild.querySelectorAll('.accordion').forEach(collapsableContent => {
      window.setAccordionState(collapsableContent, false);
    });

    if (lastChild.classList.contains('accordion')) {
      window.setAccordionState(lastChild, false);
    }

    lastChild.querySelectorAll('button, input, a').forEach(focusable => {
      focusable.setAttribute('tabindex', '-1');
    });
  }

  // Add/remove any event listeners for a no-click hamburger menu
  if (menuContainer.classList.contains('no-click')) {
    // Store the function reference on the menuContainer for later removal
    if (!menuContainer.clickOutsideHandler) {
      menuContainer.clickOutsideHandler = (event) => {
        if (!menuContainer.contains(event.target)) {
          toggleHamburgerMenu(menuContainer, toggle);
        }
      };
    }

    (isActive) ? 
      document.addEventListener('click', menuContainer.clickOutsideHandler) 
    : 
      document.removeEventListener('click', menuContainer.clickOutsideHandler);
  }
}
window.toggleHamburgerMenu = toggleHamburgerMenu;

function initHamburgerMenu() { 
  document.querySelectorAll('.hamburger__menu').forEach(menuContainer => {
    const mainToggle = menuContainer.querySelector('.hamburger__toggle:not(.content__toggle)');
    const contentToggle = menuContainer.querySelector('.hamburger__toggle.content__toggle');

    // Set the ARIA attributes instead of relying on manual HTML setup
    if (mainToggle) {
      mainToggle.setAttribute('aria-controls', menuContainer.lastElementChild.id || '');
      mainToggle.setAttribute('aria-expanded', 'false');
      mainToggle.setAttribute('role', 'button');
    }

    if (contentToggle) {
      contentToggle.setAttribute('aria-controls', menuContainer.lastElementChild.id || '');
      contentToggle.setAttribute('role', 'button');
    }
  
    if (menuContainer.classList.contains('hamburger__external-toggle')) {
      return;
    }
    
    // Main hamburger toggle (outside content) 
    if (mainToggle && !mainToggle.hasHamburgerListener) {
      mainToggle.addEventListener('click', (event) => {
        toggleHamburgerMenu(menuContainer, mainToggle);
      });
      mainToggle.hasHamburgerListener = true;
    }

    // Hamburger toggle inside content
    if (contentToggle && !contentToggle.hasHamburgerListener) {
      contentToggle.addEventListener('click', (event) => {
        toggleHamburgerMenu(menuContainer, contentToggle);
      });
      contentToggle.hasHamburgerListener = true;
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initCollapsableContents();
  initHamburgerMenu();
});


/* ========================================================================== */
/*                     HEADER FUNCTION OVERLAY LOGIC                          */
/* ========================================================================== */
function getHeaderHeight(type = 'total') {
  let height = 0;

  const cssSelector = (document.querySelector('.shopify-section-group-header-group') !== null ) ? '.shopify-section-group-header-group' : 'header';
  document.querySelectorAll(cssSelector).forEach(el => {
    let containsHeader = false;
    if (cssSelector !== 'header') {
      containsHeader = Array.from(el.childNodes).some(child => child.classList && child.classList.contains('site-header'));
    } else {
      containsHeader = true;
    }

    const containsAnnouncement = Array.from(el.childNodes).some(child => child.classList && child.classList.contains('announcement-bar'));
    if (type === 'total') {
      height += el.clientHeight;
    } else if (type === 'header' && containsHeader) {;
      height += el.clientHeight;
    } else if (type === 'announcement' && containsAnnouncement) {
      height += el.clientHeight;
    }
  });

  if (type === 'total') {
    document.documentElement.style.setProperty('--header-height-total', `${height}px`);
  } else if (type === 'header') {
    document.documentElement.style.setProperty('--header-height-header', `${height}px`);
  } else if (type === 'announcement') {
    document.documentElement.style.setProperty('--header-height-announcement', `${height}px`);
  }
  return height;
}
window.getHeaderHeight = getHeaderHeight;

let headerOverlayScrollY = 100;
function canHeaderOverlay() {
  const header = document.querySelector('header');
  const headerSection = header.parentElement;
  if (!header || !headerSection) {
    // No header or header section found, cannot overlay
    return false;
  }

  // Condition 1: The user cannot be on mobile
  if (document.documentElement.clientWidth < 1025) {
    return false;
  }

  // Condition 2: The header overlay setting must match the corresponding current page 
  const headerStyle = window.getComputedStyle(header);
  const headerOverlayHomepage = headerStyle.getPropertyValue('--header-overlay-homepage').trim() === 'true';
  const headerOverlayProduct = headerStyle.getPropertyValue('--header-overlay-product').trim() === 'true';
  const headerOverlayCollection = headerStyle.getPropertyValue('--header-overlay-collection').trim() === 'true';
  const headerOverlayPassword = headerStyle.getPropertyValue('--header-overlay-password').trim() === 'true';
  
  if (window.location.pathname === '/' && !headerOverlayHomepage) {
    //console.log('Header overlay: Homepage overlay disabled in settings');
    return false;
  }

  if (window.location.pathname.includes('/products/') && !headerOverlayProduct) {
    //console.log('Header overlay: Product overlay disabled in settings');
    return false;
  }

  if (window.location.pathname.includes('/collections/') && !headerOverlayCollection) {
    //console.log('Header overlay: Collection overlay disabled in settings');
    return false;
  }

  if (window.location.pathname.includes('/password') && !headerOverlayPassword) {
    //console.log('Header overlay: Password overlay disabled in settings');
    return false;
  }
  
  // Condition 3: There must be a header-overlay-compatible element directory after the header
  let nextSection = document.getElementById('layout__sections').firstElementChild;
  while (nextSection && nextSection.querySelector('.header-overlay-compatible__skip') !== null) {
    //console.log('Header overlay: Skipping section without header-overlay-compatible__skip:', nextSection);
    nextSection = nextSection.nextElementSibling;
  }

  if (window.location.pathname === '/password') {
    nextSection = headerSection.nextElementSibling;
  }

  if (!nextSection) {
    console.log('Header overlay: No next section found');
    return false;
  }

  if (!nextSection || !Array.from(nextSection.childNodes).some(child => child.classList && child.classList.contains('header-overlay-compatible'))) {
    //console.log('Header overlay: No header-overlay-compatible element found');
    //console.log('Header overlay debug - next section:', nextSection);
    return false;
  }

  // Condition 4: The window.scrollY must be under a certain threshold
  if (window.scrollY > headerOverlayScrollY) {
    //console.log('Header overlay: Scroll position too high:', window.scrollY);
    return false;
  }
  
  // Condition 5: There must be no conflicting header-overlay-disabled elements
  if (document.querySelectorAll('.header-overlay-disabled.active').length > 0) {
    //console.log('Header overlay: Header-overlay-disabled elements found');
    return false;
  }

  // All conditions are met
  return true;
}
window.canHeaderOverlay = canHeaderOverlay;


// ASSUMES THE HEADER CAN BE OVERLAID WITHOUT ANY ISSUES
function toggleHeaderOverlay(enable, instantTransition = false) {
  const header = document.querySelector('header');

  if (header) {
    const headerLogo = header.querySelector('.header__logo');
    
    if (instantTransition) {
      header.classList.add('instant-transition');
      // Force reflow to ensure instant-transition class is applied
      void header.offsetHeight;
      applyHeaderOverlayChanges();
    } else {
      header.classList.remove('instant-transition');
      applyHeaderOverlayChanges();
    }

    function applyHeaderOverlayChanges() {
      if (enable) {
        header.classList.add('header--overlay');
        header.classList.remove('header--overlay-disabled');
        
        if (headerLogo) headerLogo.style.transform = '';
      } else {
        header.classList.remove('header--overlay');
        header.classList.add('header--overlay-disabled');

        if (window.scrollY > headerOverlayScrollY && document.documentElement.clientWidth > 768) {
          if (headerLogo) headerLogo.style.transform = 'scale(0.8)';
        } else if (window.scrollY < headerOverlayScrollY && document.documentElement.clientWidth > 768) {
          if (headerLogo) headerLogo.style.transform = '';
        }
      }
      // Force reflow to commit overlay changes before re-enabling transitions,
      // preventing the browser from batching the class change and transition
      // re-enable into one animated frame.
      void header.offsetHeight;
      header.classList.remove('instant-transition');
      
    }
  }
}
window.toggleHeaderOverlay = toggleHeaderOverlay;

function softToggleHeaderOverlay() { 
  toggleHeaderOverlay(canHeaderOverlay());
}
window.softToggleHeaderOverlay = softToggleHeaderOverlay;



// Set this to match your EXACT CSS transition duration for the accordion
const TRANSITION_DURATION_MS = getTransitionMsFromCss(document.querySelector('.header__menu__accordion > li > .accordion__content'));

let directionAnchorY = window.scrollY;
let isHeaderOpen = true; // Tracks actual state to prevent redundant DOM updates
let isAnimating = false; // Locks the listener during layout shifts
let ticking = false;

// Manages overflow:visible on the header nav.
// overflow:visible is needed for the ::after underline at bottom:-4px, but must be absent
// during the open animation (grid 0fr→1fr needs overflow:hidden to clip the reveal).
// Solution: add it only after transitionend, remove it before the close animation starts.
const headerNav = document.querySelector('.header__menu__accordion > li > .accordion__content');
let navOpenTransitionHandler = null;

function getTransitionMsFromCss(element) {
  if (!element) return 300; // Safe fallback

  // Read the custom property from the inline style or computed styles
  const transitionValue = element.style.getPropertyValue('--transition') || 
                          getComputedStyle(element).getPropertyValue('--transition');
  
  const cleanValue = transitionValue.trim().toLowerCase();

  // Convert 's' to milliseconds, or return 'ms' directly
  if (cleanValue.endsWith('ms')) {
    return parseFloat(cleanValue) || 300;
  } else if (cleanValue.endsWith('s')) {
    return (parseFloat(cleanValue) * 1000) || 300;
  }
  
  return 300; // Fallback if format is unrecognized
}

function setNavOverflow(open) {
  if (!headerNav) return;
  if (navOpenTransitionHandler) {
    headerNav.removeEventListener('transitionend', navOpenTransitionHandler);
    navOpenTransitionHandler = null;
  }
  if (open) {
    navOpenTransitionHandler = (e) => {
      if (e.propertyName !== 'grid-template-rows') return;
      headerNav.removeEventListener('transitionend', navOpenTransitionHandler);
      navOpenTransitionHandler = null;
      if (headerNav.classList.contains('active')) {
        headerNav.classList.add('header-nav-open');
      }
    };
    headerNav.addEventListener('transitionend', navOpenTransitionHandler);
  } else {
    headerNav.classList.remove('header-nav-open');
  }
}

window.addEventListener('scroll', () => {
  if (!ticking) {
    window.requestAnimationFrame(() => {
      const currentScrollY = window.scrollY;
      softToggleHeaderOverlay();

      // FIX 1: Guard against macOS/iOS elastic "rubber-band" scrolling at the top
      if (currentScrollY <= 0) {
        handleHeaderStateChange(true, currentScrollY);
        directionAnchorY = currentScrollY;
        ticking = false;
        return;
      }

      // FIX 2: Ignore any scroll events that fire while the header is animating
      if (isAnimating) {
        directionAnchorY = currentScrollY; 
        ticking = false;
        return;
      }

      const delta = currentScrollY - directionAnchorY;

      // Require 10px sustained movement to filter out micro-jitters
      if (Math.abs(delta) > 10) {
        const scrollDirectionDown = delta > 0;
        
        // Assuming headerOverlayScrollY is declared globally in your file
        const shouldAccordionOpen = currentScrollY <= headerOverlayScrollY || !scrollDirectionDown;

        handleHeaderStateChange(shouldAccordionOpen, currentScrollY);
        
        directionAnchorY = currentScrollY;
      }

      ticking = false;
    });
    ticking = true;
  }
});

function handleHeaderStateChange(shouldOpen, currentScrollY) {
  // FIX 3: Break the infinite loop by aborting if the header is already in the target state
  if (isHeaderOpen === shouldOpen) return;

  isHeaderOpen = shouldOpen;
  isAnimating = true; 

  setNavOverflow(shouldOpen);
  window.setAccordionState(document.querySelector('.header__menu__accordion'), shouldOpen);
  document.querySelectorAll('.shopify-section > .header-aligned').forEach(el => {
    window.positionSection(el);
  });
  // FIX 4: Unlock scroll detection strictly AFTER the CSS transition and layout shifts finish
  setTimeout(() => {
    isAnimating = false;
    // Reset the anchor to wherever the page settled after the accordion finished shifting the layout
    directionAnchorY = window.scrollY; 
  }, TRANSITION_DURATION_MS);
}


document.addEventListener('readystatechange', () => {
  if (document.readyState === 'interactive') {
    toggleHeaderOverlay(canHeaderOverlay(), true);
  }
});

document.addEventListener('DOMContentLoaded', () => {
  toggleHeaderOverlay(canHeaderOverlay(), true);
  // Nav starts with active pre-applied in HTML — no open animation occurs on load,
  // so add header-nav-open immediately so the ::after underline is available.
  if (headerNav && headerNav.classList.contains('active')) {
    headerNav.classList.add('header-nav-open');
  }

  const overlayDisabledElements = document.querySelectorAll('.header-overlay-disabled');

  // 2. Only execute if at least one element exists on the page
  if (overlayDisabledElements.length > 0) {
    // 3. Define the observer logic ONCE for memory efficiency
    const classObserver = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        // Verify the change was specifically to the class attribute
        if (mutation.attributeName === 'class' && mutation.target.classList.contains('active')) {
            // Safely call the function if it exists in the current scope
            handleHeaderStateChange(true);
            toggleHeaderOverlay(false);
        }
      }
    });

    // 4. Loop through the NodeList and attach the observer to every single element
    overlayDisabledElements.forEach((element) => {
      classObserver.observe(element, { 
        attributes: true, 
        attributeFilter: ['class'] // Performance safeguard: ONLY watch for class changes
      });
    });
  }
});

let headerTimeout;
window.addEventListener('resize', () => {
  clearTimeout(headerTimeout);
  headerTimeout = setTimeout(() => {
    toggleHeaderOverlay(canHeaderOverlay());
    clearTimeout(headerTimeout);
  }, 20);
});

window.addEventListener('resize', () => {
  // On resize, close hamburger menu if switching to desktop
  document.querySelectorAll('.hamburger__menu').forEach(menuContainer => {
    const menu = menuContainer.lastElementChild ? menuContainer.lastElementChild : menuContainer;
    if (document.documentElement.clientWidth > 1024 && menu.classList.contains('active')) {
      menu.classList.remove('active');
      const toggle = menuContainer.querySelector('.hamburger__toggle');
      if (toggle) {
        toggle.classList.remove('bi-x-lg');
        toggle.classList.add('bi-list');
      }
    }
  });
});
/* ========================================================================== */

/* ========================================================================== */
/*                        OVERLAY TOGGLE LOGIC                                */
/* ========================================================================== */
function toggleOverlay(overlayContainer) {
  if (!overlayContainer) return;
  
  overlayContainer.classList.toggle('active');

  const isActive = overlayContainer.classList.contains('active');
  
  if (isActive) {
    overlayContainer.removeAttribute('inert');
  } else {
    overlayContainer.setAttribute('inert', '');
  }

  overlayContainer.setAttribute('tabindex', isActive ? '0' : '-1');
  overlayContainer.setAttribute('aria-modal', isActive ? 'true' : 'false');
}
window.toggleOverlay = toggleOverlay;

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.overlay').forEach(container => {
    const background = container.querySelector('.overlay__background');
    const content = container.querySelector('.overlay__content');
    
    // Close overlay when clicking the background
    if (background) {
      background.addEventListener('click', function() {
        toggleOverlay(container);
      });
    }
    
    // Prevent closing when clicking the content
    if (content) {
      content.addEventListener('click', function(e) {
        e.stopPropagation();
      });
    }
  });
});
/* ========================================================================== */
/*                     FULLSCREEN SECTION LOGIC - FIXED                       */
/* ========================================================================== */

function positionSection(element) {
  const elementSection = element.parentElement;

  const desktopFullScreen = element.classList.contains('full_screen__desktop');
  const mobileFullScreen = element.classList.contains('full_screen__mobile');

  const desktopHeight = `${getComputedStyle(element).getPropertyValue('--desktop-height')}` || elementSection.clientHeight + 'px';
  const mobileHeight = `${getComputedStyle(element).getPropertyValue('--mobile-height')}` || elementSection.clientHeight + 'px';

  let headerOverlay = false;
  const header = document.querySelector('header');
  const headerStyle = window.getComputedStyle(header);

  const headerOverlayHomepage = headerStyle.getPropertyValue('--header-overlay-homepage').trim() === 'true';
  const headerOverlayProduct = headerStyle.getPropertyValue('--header-overlay-product').trim() === 'true';
  const headerOverlayCollection = headerStyle.getPropertyValue('--header-overlay-collection').trim() === 'true';
  const headerOverlayPassword = headerStyle.getPropertyValue('--header-overlay-password').trim() === 'true';

  if (header.classList.contains('header--overlay-disabled') || document.documentElement.clientWidth < 1025) {
    headerOverlay = false;
  } else if (window.location.pathname === '/' && headerOverlayHomepage) {
    headerOverlay = true;
  } else if (window.location.pathname.includes('/products/') && headerOverlayProduct) {
    headerOverlay = true;
  } else if (window.location.pathname.includes('/collections/') && headerOverlayCollection) {
    headerOverlay = true;
  } else if (window.location.pathname.includes('/password') && headerOverlayPassword) {
    headerOverlay = true;
  }

  let height = desktopHeight

  if (document.documentElement.clientWidth < 1025) {
    height = mobileHeight;
  }

  let top = '0px';
  let heightCalc = (element.classList.contains('dvh')) ? '100dvh' : '100svh';
  let position = 'relative';
  let paddingTop = '0px';
  if (desktopFullScreen && document.documentElement.clientWidth > 1024) {
    if (headerOverlay) {
      height = `calc(${heightCalc} - ${window.getHeaderHeight('announcement')}px)`;
      top = `-${window.getHeaderHeight('header')}px`;
    } else {
      height = `calc(${heightCalc} - ${window.getHeaderHeight('total')}px)`;
      top = '0px';
      position = '';
    }
  } else if (mobileFullScreen && document.documentElement.clientWidth < 1025) {
    height = `calc(${heightCalc} - ${window.getHeaderHeight('total')}px)`;
    if (!headerOverlay) {
      position = '';
    }
    if (elementSection.classList.contains('hamburger__menu')) {
      element.style.top = `${window.getHeaderHeight('total')}px`;
    }
  } else if (headerOverlay && document.documentElement.clientWidth > 1025) {
    top = `-${window.getHeaderHeight('header')}px`;
  }

  requestAnimationFrame(() => {
    element.style.height = height;
    elementSection.style.top = top;
    elementSection.style.position = position;
    elementSection.style.paddingTop = paddingTop;

    if (top.startsWith('-')) {
      elementSection.style.marginBottom = top;
    } else {
      elementSection.style.marginBottom = '0px';
    }
  });
  
  if (top.startsWith('-')) {
    elementSection.style.marginBottom = top;
  } else {
    elementSection.style.marginBottom = '0px';
  }
}
window.positionSection = positionSection;


/**
 * Positions a "sticky" element to be aligned below the header.
 * @param {HTMLElement} element 
 * @returns {void}
 */
function positionStickyElement(element) {
  if (!element || document.documentElement.clientWidth < 768) return;

  if (document.documentElement.clientWidth < 1025 && !element.classList.contains('tablet-allowed')) {
    return; // Skip positioning for non-tablet allowed elements on mobile
  }

  const headerHeight = document.querySelector('.header__sections').offsetHeight;
  const topSpacing = parseInt(getComputedStyle(element).getPropertyValue('--top-spacing')) || 0;

  element.style.setProperty('--top', `${headerHeight + topSpacing}px`);
}

// Apply positioning as early as possible - BEFORE scroll restoration
function earlyPositionSections() {
  const elements = document.querySelectorAll('.header-overlay-compatible');
  elements?.forEach(element => {
    positionSection(element);
  });

  document.querySelectorAll('.aligned-sticky').forEach(stickyElement => {
    positionStickyElement(stickyElement);
  });
}

// Run immediately when script loads (synchronously)
if (document.readyState === 'loading') {
  // If DOM is still loading, listen for interactive state (before DOMContentLoaded)
  const checkAndPosition = () => {
    if (document.readyState === 'interactive' || document.readyState === 'complete') {
      earlyPositionSections();
    }
  };
  
  document.addEventListener('readystatechange', checkAndPosition);
  
  // Also try on DOMContentLoaded as backup
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
      document.querySelectorAll('.header-overlay-compatible')?.forEach(element => {
        positionSection(element);
      });

      document.querySelectorAll('.aligned-sticky').forEach(stickyElement => {
        positionStickyElement(stickyElement);
      });
    }, 100);
  });
} else {
  // DOM already loaded, run immediately
  earlyPositionSections();
}

// Re-run sticky positioning whenever <header>'s own rendered height changes
// (e.g. the collapsible nav accordion opening/closing on scroll), not just
// on scroll/resize - ResizeObserver catches this regardless of cause.
document.addEventListener('DOMContentLoaded', () => {
  const headerElementForResize = document.querySelector('header');
  if (headerElementForResize && window.ResizeObserver) {
    const headerResizeObserver = new ResizeObserver(() => {
      document.querySelectorAll('.aligned-sticky').forEach(stickyElement => {
        positionStickyElement(stickyElement);
      });
    });
    headerResizeObserver.observe(headerElementForResize);
  }
});

let resizeTimeout;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    document.querySelectorAll('.header-overlay-compatible')?.forEach(element => {
      positionSection(element);
    });
  }, 300);
});
/* ========================================================================== */
function isTouchDevice() {
  return (
    'ontouchstart' in window || // Check for the DOM event
    navigator.maxTouchPoints > 0 || // Check for maximum touch points
    navigator.msMaxTouchPoints > 0 // Vendor-prefixed check for older IE
  );
}
window.isTouchDevice = isTouchDevice;
/* ========================================================================== */